import type { DataCollection } from '@sentry/core';

const NETWORK_IDENTITY_KEYS = ['forwarded', '-ip', 'remote-', 'via', '-user'];

// Sentry v11 collects cookies, headers, and request/response bodies unless
// told otherwise; that would send session cookies and form posts to Sentry.
// This is the v10 default (`sendDefaultPii` unset) from Sentry's migration
// guide. Pass it to every `Sentry.init`.
export const restrictedDataCollection: DataCollection = {
   userInfo: false,
   cookies: false,
   httpHeaders: {
      request: { deny: NETWORK_IDENTITY_KEYS },
      response: { deny: NETWORK_IDENTITY_KEYS },
   },
   httpBodies: [],
   urlQueryParams: { deny: NETWORK_IDENTITY_KEYS },
   genAI: { inputs: false, outputs: false },
   mcp: { inputs: false, outputs: false },
   databaseQueryData: false,
   queues: false,
   graphQL: { document: false, variables: false },
};
